import type { PostUnion } from 'types';

interface Breadcrumb {
  label?: string;
  link?: string;
}

type PostType =
  | 'ContentfulTemplateBlogPost'
  | 'ContentfulTemplateNewsPost'
  | 'ContentfulTemplateCaseStudy'
  | 'ContentfulTemplateResourceCenter'
  | 'ContentfulTemplateWebinar';

interface BasePathConfig {
  label: string;
  path: string;
  isSpecial?: boolean;
}

const BASE_PATHS: Record<PostType, BasePathConfig> = {
  ContentfulTemplateBlogPost: {
    label: 'Blog',
    path: 'blog',
  },
  ContentfulTemplateNewsPost: {
    label: 'News',
    path: 'news',
  },
  ContentfulTemplateCaseStudy: {
    label: 'Case Studies',
    path: 'case-studies',
  },
  ContentfulTemplateResourceCenter: {
    label: 'Resource Center',
    path: '',
    isSpecial: true,
  },
  ContentfulTemplateWebinar: {
    label: 'Webinars',
    path: 'webinars',
  },
};

export const generateBreadcrumbs = (post: PostUnion): Breadcrumb[] => {
  const { __typename, slug, title } = post;

  if (!__typename || !(__typename in BASE_PATHS)) {
    return [];
  }

  const basePath = BASE_PATHS[__typename as PostType];
  const breadcrumbs: Breadcrumb[] = [];

  const typeToPathMap: Record<string, string> = {
    Guide: 'guides',
    Template: 'templates',
    Tool: 'tools',
  };

  const type = post?.__typename === 'ContentfulTemplateResourceCenter' ? post?.type : undefined;
  const resourceTypePath = type ? typeToPathMap[type] || '' : '';

  if (__typename === 'ContentfulTemplateResourceCenter') {
    breadcrumbs.push({
      label: type as string,
      link: `/${resourceTypePath}`,
    });
  } else {
    breadcrumbs.push({
      label: basePath.label,
      link: `/${basePath.path}`,
    });
  }

  breadcrumbs.push({
    label: title as string,
    link: `/${basePath.path}${__typename === 'ContentfulTemplateResourceCenter' ? `/${resourceTypePath}` : ''}/${slug}`,
  });

  return breadcrumbs;
};
